import React from 'react'
import Avatar from 'react-avatar'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeSanitize from 'rehype-sanitize'
import bitbeanAvatar from '../../static/bitbean_chat.png'
import MermaidRenderer from './Renderer/MermaidRenderer'
import { useUserAvatarCache } from '../../hooks/useUserAvatarCache.ts'

const ChatMessage = ({ message, kedo }) => {
    const isUser = message.sender === 'user'
    const isBot = message.sender === 'bot'
    const text = message.text || ''

    const userId = isUser ? kedo.user().getUserId() : null
    const avatarSrc = useUserAvatarCache(kedo, userId)

    return (
        <div className={`chat-message ${isUser ? 'user' : 'bot'}`}>
            {isBot && (
                <img
                    src={bitbeanAvatar}
                    alt="BitBean"
                    className="chat-avatar"
                />
            )}

            <div className={`chat-bubble ${isUser ? 'user' : 'bot'}`}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeSanitize]}
                    components={{
                        code({ className, children }) {
                            const lang = (className || '').replace(
                                'language-',
                                ''
                            )
                            if (lang === 'mermaid') {
                                return (
                                    <MermaidRenderer
                                        chart={
                                            Array.isArray(children)
                                                ? children.join('')
                                                : children
                                        }
                                    />
                                )
                            }
                            return (
                                <pre>
                                    <code>{children}</code>
                                </pre>
                            )
                        },
                    }}
                >
                    {text}
                </ReactMarkdown>
            </div>

            {isUser && (
                <Avatar
                    round
                    size={36}
                    alt={kedo.user().firstName}
                    src={avatarSrc}
                />
            )}
        </div>
    )
}

export default ChatMessage
